module.exports = __webpack_public_path__ + "img/gzh.24b67a65.jpg";